import styled from 'styled-components';

const Block = styled.section`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

export function stripHtml(html) {
  return String(html || '')
    .replace(/<[^>]+>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export default function CrawlerSeoContent({
  title,
  intro,
  bodyParagraphs = [],
  faqs = [],
}) {
  const paragraphs = bodyParagraphs.map(stripHtml).filter(Boolean);
  const hasContent = title || intro || paragraphs.length || faqs.length;
  if (!hasContent) return null;

  return (
    <Block aria-hidden="true">
      {title ? <h1>{title}</h1> : null}
      {intro ? <p>{stripHtml(intro)}</p> : null}
      {paragraphs.map((text, i) => (
        <p key={i}>{text}</p>
      ))}
      {faqs.length > 0 ? (
        <dl>
          {faqs.map((f, i) => (
            <div key={i}>
              <dt>{f.question || f.q}</dt>
              <dd>{stripHtml(f.answer || f.a)}</dd>
            </div>
          ))}
        </dl>
      ) : null}
    </Block>
  );
}
